import type { ReviewedLibraryIdentity } from './library-identity-types';

export const LIBRARY_SHOULDERS_01: ReviewedLibraryIdentity[] = [
  {
    "id": "library-prone-dumbbell-fly",
    "name": "俯卧哑铃反向飞鸟",
    "group": "shoulders",
    "subCategory": "rear-deltoid",
    "equipment": "dumbbell",
    "pattern": "俯卧哑铃肩水平外展",
    "legacyIds": [
      "prone-dumbbell-fly"
    ],
    "sourceId": "course-20261008-four-way-04-03",
    "targetMuscles": [
      "三角肌后束",
      "斜方肌中下部"
    ],
    "evidence": "不能与徒手反向飞鸟合并；当前两项上传角色错配，标准库明确待补"
  },
  {
    "id": "library-cable-face-pull",
    "name": "坐姿绳索面拉",
    "group": "shoulders",
    "subCategory": "rear-deltoid",
    "equipment": "cable",
    "pattern": "坐姿水平拉及肩外旋",
    "legacyIds": [
      "cable-face-pull",
      "threeway-behind-neck-tricep"
    ],
    "sourceId": "course-20261008-four-way-04-07",
    "targetMuscles": [
      "三角肌后束",
      "斜方肌中下部"
    ],
    "evidence": "主线程核对旧三分化颈后臂屈伸视频实际为坐姿绳索面拉；只修正标准库，原合集位置和媒体不变"
  },
  {
    "id": "library-home-prone-reverse-fly",
    "name": "俯卧徒手反向飞鸟",
    "group": "shoulders",
    "subCategory": "rear-deltoid",
    "equipment": "bodyweight",
    "pattern": "地面俯卧徒手肩水平外展",
    "legacyIds": [
      "home-prone-reverse-fly"
    ],
    "sourceId": "course-20261008-home-01-06",
    "targetMuscles": [
      "三角肌后束",
      "斜方肌中下部"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-home-seated-dumbbell-rear-fly",
    "name": "坐姿双哑铃俯身飞鸟",
    "group": "shoulders",
    "subCategory": "rear-deltoid",
    "equipment": "dumbbell",
    "pattern": "坐姿双臂肩水平外展",
    "legacyIds": [
      "home-seated-dumbbell-rear-fly"
    ],
    "sourceId": "course-20261008-home-04-06",
    "targetMuscles": [
      "三角肌后束",
      "斜方肌中下部"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-home-seated-dumbbell-press",
    "name": "坐姿哑铃推举",
    "group": "shoulders",
    "subCategory": "front-deltoid",
    "equipment": "dumbbell",
    "pattern": "坐姿双哑铃垂直推",
    "legacyIds": [
      "home-seated-dumbbell-press",
      "personal-s5-dumbbell-shoulder-press"
    ],
    "sourceId": "course-20261008-home-04-03",
    "targetMuscles": [
      "三角肌前束",
      "三角肌中束",
      "肱三头肌"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-ksw-y-raise",
    "name": "单臂绳索Y字侧平举",
    "group": "shoulders",
    "subCategory": "side-deltoid",
    "equipment": "cable",
    "pattern": "单臂绳索肩外展",
    "legacyIds": [
      "ksw-y-raise"
    ],
    "sourceId": "course-20261008-ksw-collection-01-12",
    "targetMuscles": [
      "三角肌中束"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-threeway-lateral-raise",
    "name": "双臂哑铃侧平举",
    "group": "shoulders",
    "subCategory": "side-deltoid",
    "equipment": "dumbbell",
    "pattern": "双臂哑铃肩外展",
    "legacyIds": [
      "threeway-lateral-raise",
      "personal-s5-lateral-raise"
    ],
    "sourceId": "course-20261008-home-04-05",
    "targetMuscles": [
      "三角肌中束"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-threeway-seated-reverse-fly",
    "name": "坐姿器械反向飞鸟",
    "group": "shoulders",
    "subCategory": "rear-deltoid",
    "equipment": "machine",
    "pattern": "坐姿器械肩水平外展",
    "legacyIds": [
      "threeway-seated-reverse-fly"
    ],
    "sourceId": "course-20261008-four-way-04-06",
    "targetMuscles": [
      "三角肌后束",
      "斜方肌中下部"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-threeway-cable-reverse-fly",
    "name": "站姿绳索反向飞鸟",
    "group": "shoulders",
    "subCategory": "rear-deltoid",
    "equipment": "cable",
    "pattern": "站姿双臂绳索肩水平外展",
    "legacyIds": [
      "threeway-cable-reverse-fly",
      "personal-s2-cable-reverse-fly"
    ],
    "sourceId": "course-20261008-personal-02-09",
    "targetMuscles": [
      "三角肌后束",
      "斜方肌中下部"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-threeway-smith-press",
    "name": "史密斯推肩",
    "group": "shoulders",
    "subCategory": "front-deltoid",
    "equipment": "machine",
    "pattern": "史密斯垂直推",
    "legacyIds": [
      "threeway-smith-press"
    ],
    "sourceId": "course-20261008-fanjue-plan-12-02",
    "targetMuscles": [
      "三角肌前束",
      "三角肌中束",
      "肱三头肌"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-personal-s4-shoulder-work",
    "name": "绳索肩部前束训练",
    "group": "shoulders",
    "subCategory": "front-deltoid",
    "equipment": "cable",
    "pattern": "绳索肩屈",
    "legacyIds": [
      "personal-s4-shoulder-work"
    ],
    "sourceId": "course-20261008-personal-04-06",
    "targetMuscles": [
      "三角肌前束"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-personal-s5-bent-over-rear-delt",
    "name": "俯身哑铃肩伸后束训练",
    "group": "shoulders",
    "subCategory": "rear-deltoid",
    "equipment": "dumbbell",
    "pattern": "俯身哑铃肩伸",
    "legacyIds": [
      "personal-s5-bent-over-rear-delt"
    ],
    "sourceId": "course-20261008-personal-05-03",
    "targetMuscles": [
      "三角肌后束",
      "斜方肌中下部"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  }
];
